import { getGridSignFromPower } from '../../common/bulkOrder/gridAxisUtils'
import { resolveGridSide } from '../../common/bulkOrder/sideUtils'

/**
 * Which grid controls change when focusing a recap line (for pulse + focus delay).
 * Addition sign only for addition-axis non-zero lines that need a different preference.
 */
export const getRecapChangedControls = (
  line,
  gridContext,
  { isAdditionGrid, isSideEnabled } = {},
) => {
  const changedControls = []

  if (gridContext.diameter !== line.diameter) changedControls.push('diameter')
  if (isSideEnabled !== false && gridContext.side !== line.side) changedControls.push('side')

  if (isAdditionGrid) {
    const addition = line.addition ?? 0
    if (addition !== 0) {
      const neededSign = getGridSignFromPower(addition)
      if (gridContext.additionSign !== neededSign) {
        changedControls.push('additionSign')
      }
    }
  }

  return changedControls
}

/**
 * Grid context patch for a recap line click.
 * Sets additionSign for addition-axis non-zero lines; leaves cylinderSign alone.
 */
export const getRecapGridContextPatch = (line, { hasSideSelection, isAdditionGrid } = {}) => {
  const patch = {
    diameter: line.diameter,
    side: resolveGridSide(hasSideSelection, line.side),
  }

  if (isAdditionGrid) {
    const addition = line.addition ?? 0
    if (addition !== 0) {
      patch.additionSign = getGridSignFromPower(addition)
    }
  }

  return patch
}
